export class FetchToolTimeSettingsAction {
  static readonly type = '[Tool Time Settings] Fetch Settings';

  constructor() {
  }
}
